import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { ChartColumn } from "../../../../Constant";
import Chart from "react-apexcharts";
import { ANNOTATION_CHART } from "../../../../Data/Charts/ApexChart";

const ColumnCharts = () => {
  return (
    <Col sm="12" xl="12" className="box-col-6">
      <Card>
        <CommonCardHeader title={ChartColumn} />
        <CardBody>
          <div id="annotationchart">
            <Chart options={ANNOTATION_CHART} series={ANNOTATION_CHART.series} type="line" height={350} />
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default ColumnCharts;
